import { SliceItemContent } from "@prismicio/types-internal/lib/content"

import type { SliceTrackingArgs } from "../../../../app/services/tracking"
import { useDocument } from "../../../DocumentProvider"
import { getSliceTitle, type VisualSlice } from "../sliceTableData"

export function useGetSliceTrackingInfo() {
  const { title, customType } = useDocument()

  function getInfo(slice: VisualSlice): SliceTrackingArgs
  function getInfo(slice: SliceItemContent, zoneId: string): SliceTrackingArgs
  function getInfo(
    slice: VisualSlice | SliceItemContent,
    zoneId?: string
  ): SliceTrackingArgs {
    if (SliceItemContent.is(slice)) {
      const { widget } = slice
      const isSharedSlice = widget.__TYPE__ === "SharedSliceContent"
      const isCompositeSlice = widget.__TYPE__ === "CompositeSliceContent"

      let type: SliceTrackingArgs["type"]

      if (isSharedSlice) {
        type = "shared"
      } else if (isCompositeSlice) {
        type = "composite"
      } else {
        type = "simple"
      }

      const info: SliceTrackingArgs = {
        customtypeId: customType.id,
        documentName: title ?? "",
        id: slice.key,
        sliceName: slice.name,
        type,
        variation: isSharedSlice ? widget.variation : "",
        zone: zoneId ?? ""
      }

      return info
    }

    const isSharedSlice = slice.type === "shared"
    const info: SliceTrackingArgs = {
      id: isSharedSlice ? slice.config.id : slice.description,
      variation: isSharedSlice ? slice.variation.id : "",
      zone: slice.zoneId,
      type: slice.type,
      customtypeId: customType.id,
      documentName: title ?? "",
      sliceName: isSharedSlice ? getSliceTitle(slice).title : slice.description
    }

    return info
  }

  return getInfo
}
